module.exports = __webpack_public_path__ + "i18n/de.426991e26fb853e7761e131062b0e070.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1283
// module chunks = 60